import { render, staticRenderFns } from "./PCPolicyGuide.vue?vue&type=template&id=2da451d0&scoped=true"
import script from "./PCPolicyGuide.vue?vue&type=script&lang=js"
export * from "./PCPolicyGuide.vue?vue&type=script&lang=js"
import style0 from "./PCPolicyGuide.vue?vue&type=style&index=0&id=2da451d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da451d0",
  null
  
)

export default component.exports